export default {
      id: "icon-delivery-usage",
      viewBox: "0 0 118 81",
      url: __webpack_public_path__ + "icons.svg#icon-delivery",
      toString: function () {
        return this.url;
      }
    }